var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('vue-vimeo-player',{attrs:{"video-id":_vm.videoId,"autoplay":_vm.autoplay,"loop":_vm.loop,"controls":_vm.controls,"player-height":_vm.playerHeight,"player-width":_vm.playerWidth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }